import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	timelineDescription: {
		id: 'tmp-feature-toggle.feature-popup-content.feature-toggle-group.feature-item.timeline-description',
		defaultMessage: 'Create and organize epics',
		description: 'description for Timeline feature',
	},
	boardDescription: {
		id: 'tmp-feature-toggle.feature-popup-content.feature-toggle-group.feature-item.board-description',
		defaultMessage: 'View, track, and manage work',
		description: 'description for Board feature',
	},
	backlogDescription: {
		id: 'tmp-feature-toggle.feature-popup-content.feature-toggle-group.feature-item.backlog-description',
		defaultMessage: 'Plan and prioritize work',
		description: 'description for Backlog feature',
	},
	issueNavigatorDescription: {
		id: 'tmp-feature-toggle.feature-popup-content.feature-toggle-group.feature-item.issue-navigator-description',
		defaultMessage: 'Browse issues in your project',
		description: 'description for Issue Navigator feature',
	},
	releasesDescription: {
		id: 'tmp-feature-toggle.feature-popup-content.feature-toggle-group.feature-item.releases-description',
		defaultMessage: 'Package and schedule project deliveries',
		description: 'description for Releases feature',
	},
	projectPagesDescription: {
		id: 'tmp-feature-toggle.feature-popup-content.feature-toggle-group.feature-item.project-pages-description',
		defaultMessage: 'Manage and maintain documents',
		description: 'description of Project Pages feature',
	},
	listDescription: {
		id: 'tmp-feature-toggle.feature-popup-content.feature-toggle-group.feature-item.list-description',
		defaultMessage: 'Manage work quickly like in a spreadsheet',
		description: 'description for List view',
	},
	issueNavigatorDescriptionIssueTermRefresh: {
		id: 'tmp-feature-toggle.feature-popup-content.feature-toggle-group.feature-item.issue-navigator-description-issue-term-refresh',
		defaultMessage: 'Browse work items in your project',
		description: 'description for Issue Navigator feature',
	},
});
